export default __webpack_public_path__ + "98aee7b20f6fa6b0d421c94d41c33613.png";